import { useQuery } from '@tanstack/react-query';
import { CASE_DETAILS_KEY } from '../../utils/constants/queryKeys';
import { getCaseDetails } from '../services/fn-api/Cases';

export const useGetCaseDetails = (caseId: number) => {
  return useQuery({
    queryKey: [CASE_DETAILS_KEY, caseId],
    queryFn: () => getCaseDetails(caseId),
    enabled: !!caseId,
  });
};
